import "./App.css";
import Navbar from "./components/Navbar/Navbar";
import About from "./components/About/About";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "./pages/Home/Home";
import AOS from "aos";
import "aos/dist/aos.css";
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import Services from "./pages/Services/Services";
import Contact from "./components/Contact/Contact";
import ContactPage from "./pages/ContactPage/ContactPage";

function App() {

  return (
    <>
      <BrowserRouter>
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/contact-us" element={<ContactPage />} />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
